import { login, setConfig } from "@scrile/tools/dist/oauth/google";
import config from "config";

setConfig({ client_id: config.googleClientId });

export default {
  login,
};
